module.exports = __webpack_public_path__ + "static/media/1f4b0.234b2d11.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/emoji/1f4b0.svg
// module id = 636
// module chunks = 1